import { api } from "../../../api/axiosInstance";

export const masterDataAPI = {
  getSubjects() {
    return api.get("/api/v1/master/subjects/");
  },
  getGenders() {
    return api.get("/api/v1/master/genders/");
  },
  getProfileTypes() {
    return api.get("/api/v1/master/profile-types/");
  },
  getLanguages() {
    return api.get("/api/v1/master/languages/");
  },
};
